var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponsiveLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1781_843",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1781_843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5V6.66667H6.66667V2.5H17.5V17.5H2.5ZM13.3333 15.8333H15.8333V4.16667H8.33333V6.66667H13.3333V15.8333ZM8.33333 15.8333H11.6667V8.33333H8.33333V15.8333ZM4.16667 15.8333H6.66667V8.33333H4.16667V15.8333Z",
    fill: "#3CB54A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveLayout);
export default __webpack_public_path__ + "static/media/responsive_layout.bc1e2892cf7718ccb00a6fbde1266199.svg";
export { ForwardRef as ReactComponent };